import { useCallback, useEffect, useRef } from 'preact/hooks';

export const useTimeoutManager = (handler: () => void, timeout: number) => {
  const timeoutRef = useRef<number>();
  const isDisabledRef = useRef(false);

  const stop = useCallback(() => {
    window.clearTimeout(timeoutRef.current);
  }, []);

  const refresh = useCallback(() => {
    stop();

    timeoutRef.current = window.setTimeout(() => {
      if (!isDisabledRef.current) {
        handler();
      }
    }, timeout);
  }, [stop, handler, timeout]);

  const disable = useCallback(() => {
    isDisabledRef.current = true;
  }, []);

  const enable = useCallback(() => {
    isDisabledRef.current = false;

    refresh();
  }, [refresh]);

  useEffect(() => {
    return () => stop();
  }, [stop]);

  return {
    stopTimeout: stop,
    refreshTimeout: refresh,
    disableTimeout: disable,
    enableTimeout: enable,
  };
};
